import type { ProductionBatchStatisticsResponse } from '@api/domain/types/statistics';
import { ProductionBatchStatistics } from '@interfaces/search';

// Re-export for consumers
export type { ProductionBatchStatisticsResponse };

// The batch data type is the statistics item from the response
export type BatchData = ProductionBatchStatistics;

export interface BatchForHover {
  id: number | null;
  shouldHover: boolean;
}

export interface BatchSquareSize {
  height: number;
  width: number;
}

export interface BatchWrapper {
  data: BatchData | null;
  wasLoaded: boolean;
}

export interface BatchState {
  batchList: BatchData[];
  batch: BatchWrapper;
  batchId: number | null;
  batchLoadedTime: string;
  batchTileHeight: number;
  batchSquareSize: BatchSquareSize;
  batchListContainerHeight: number;
  batchListYPosition: number;
  batchForHover: BatchForHover;
  batchListWidth: number;
}

export enum QuantityCorrectionReasons {
  Miscount = 'miscount',
  QualityIssue = 'qualityIssue',
}
